import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios'
import { useHistory } from "react-router-dom";
import { API_BASE_URL } from "../../Constants/ApiConstants";

const CreateBatch = () => {

    //Get Product List
    const [products, setProduct] = useState([]);

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    const result = await axios.get(`${API_BASE_URL}/v1/product/list`);
    console.log("My Data:", result.data.data)
    setProduct(result.data.data.reverse());
  };

    let history = useHistory();
    const [batch, setBatch] = useState({
        name: "",
        product_id: "",
        price_per_kg: "",
        price_per_kg_after_dressing: "",
        purchase_date: "",
        delivery_start_date: "",
        average_weight: "",
        average_weight_unit: "",
        origin: "",
        hatchery: "",
        stock_amount: "",
    });

    const {
        name,
        product_id,
        price_per_kg,
        price_per_kg_after_dressing,
        purchase_date,
        delivery_start_date,
        average_weight,
        average_weight_unit, origin, hatchery, stock_amount } = batch;

    const onInputChange = e => {
        setBatch({ ...batch, [e.target.name]: e.target.value });
    };
    console.log(batch)
    const onInputChangeDate = e => {
        //Formatting date...
        var date=new Date(e.target.value).toLocaleDateString('fr-CA')
                setBatch({ ...batch, [e.target.name]: date });
            };
            

    const onSubmit = async e => {
        e.preventDefault();
        await axios.post(`${API_BASE_URL}/v1/batch/create`, batch).then(response => { 
            console.log("Response:",response.data.message)
            toast.success(response.data.message);

        }).catch(error => {
            console.log(error.response.data.message)
            toast.error(error.response.data.message);
        });
        //history.push("/batches");
    };

    return (
        <div class="w-full h-screen overflow-x-hidden border-t flex flex-col">
            <ToastContainer />
            <main class="w-full flex-grow p-6">
                <h1 class="w-full text-3xl text-black pb-6">Create Batch</h1>
                <div className="flex flex-wrap">
                    <div className="w-full  my-6 pr-0 lg:pr-2">
                        <p className="text-xl pb-6 flex items-center">
                            <i className="fas fa-list mr-3"></i> Enter Information
                        </p>
                        <div className="leading-loose">
                            <form className="p-10 bg-white rounded shadow-xl" onSubmit={e => onSubmit(e)}>
                                <div className="">
                                    <label className="block text-sm text-gray-600" for="name">Batch Name</label>
                                    <input className="w-full px-5 py-1 text-gray-700 bg-gray-200 rounded" id="name"
                                        name="name"
                                        value={name}
                                        onChange={e => onInputChange(e)}
                                        type="text" required="true" placeholder="Unique Name" aria-label="Name" />
                                </div>

                                <div className="mt-2">
                                   <label className="block text-sm text-gray-600" for="product">Product</label>
                                    <select required="true" class="form-select form-select-sm 
                                    appearance-none 
                                    block w-full px-2 py-1
                                     text-sm font-normal
                                     w-full px-5 py-1 text-gray-700 bg-gray-200 rounded
                                      text-gray-700 bg-white bg-clip-padding bg-no-repeat
                                      border border-solid border-gray-300
                                      rounded
                                      transition
                                      ease-in-out  m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
                                      " aria-label=".form-select-lg example" onChange={e => onInputChange(e)} name="product_id">
                                        
                                        <option>Select Product</option>
                                          {products.map((product) => (
                                              <><option value={product.id}>{product.name}</option></>
                                        ))}
                                    </select>
                                </div>

                                <div className="mt-2">
                                    <label className="block text-sm text-gray-600" for="price">Price Per KG</label>
                                    <input className="w-full px-5  py-4 text-gray-700 bg-gray-200 rounded" id="price"
                                        name="price_per_kg"
                                        value={price_per_kg}
                                        onChange={e => onInputChange(e)}
                                        type="text" required="true" placeholder="Price Per KG Live" aria-label="price" />
                                </div>
                                <div className="mt-2">
                                    <label className="block text-sm text-gray-600" for="price">Price Per KG After Dressing</label>
                                    <input className="w-full px-5  py-4 text-gray-700 bg-gray-200 rounded" id="pricead"
                                        name="price_per_kg_after_dressing"
                                        value={price_per_kg_after_dressing}
                                        onChange={e => onInputChange(e)}
                                        type="text" required="true" placeholder="Price Per KG After Dressing" aria-label="pricead" />
                                </div>
                                <div className="mt-2">
                                    <label className="block text-sm text-gray-600" for="price">Purchase Date</label>
                                    <input className="w-full px-5  py-4 text-gray-700 bg-gray-200 rounded" id="purchasedate"
                                        name="purchase_date"
                                        value={purchase_date}
                                        onChange={e => onInputChangeDate(e)}
                                        type="date" required="true" placeholder="(ex:2022-02-05)" aria-label="purchasedate" />
                                </div>
                                <div className="mt-2">
                                    <label className="block text-sm text-gray-600" for="price">Delivery Start Date</label>
                                    <input className="w-full px-5  py-4 text-gray-700 bg-gray-200 rounded" id="deliverydate"
                                        name="delivery_start_date"
                                        value={delivery_start_date}
                                        onChange={e => onInputChangeDate(e)}
                                        type="date" required="true" placeholder="(ex:2022-02-05)" aria-label="deliverydate" />
                                </div>
                                <div className="mt-2">
                                    <label className="block text-sm text-gray-600" for="price">Average Weight In KG</label>
                                    <input className="w-full px-5  py-4 text-gray-700 bg-gray-200 rounded" id="averageweight"
                                        name="average_weight"
                                        value={average_weight}
                                        onChange={e => onInputChange(e)}
                                        type="text" required="true" placeholder="(ex:0.7)" aria-label="averageweight" />
                                </div>
                                <div className="mt-2">
                                    <label className="block text-sm text-gray-600" for="price">Average Weight Unit</label>
                                    <input className="w-full px-5  py-4 text-gray-700 bg-gray-200 rounded" id="averageweightunit"
                                        name="average_weight_unit"
                                        value={average_weight_unit}
                                        onChange={e => onInputChange(e)}
                                        type="text" required="true" placeholder="(ex:KG)" aria-label="averageweightunit" />
                                </div>
                                <div className="mt-2">
                                    <label className="block text-sm text-gray-600" for="price">Origin</label>
                                    <input className="w-full px-5  py-4 text-gray-700 bg-gray-200 rounded" id="origin"
                                        name="origin"
                                        value={origin}
                                        onChange={e => onInputChange(e)}
                                        type="text" required="true" placeholder="(ex:France)" aria-label="origin" />
                                </div>
                                <div className="mt-2">
                                    <label className="block text-sm text-gray-600" for="price">Hatchery</label>
                                    <input className="w-full px-5  py-4 text-gray-700 bg-gray-200 rounded" id="hatchery"
                                        name="hatchery"
                                        value={hatchery}
                                        onChange={e => onInputChange(e)}
                                        type="text" required="true" placeholder="(ex:Abul Hatchery)" aria-label="hatchery" />
                                </div>
                                <div className="mt-2">
                                    <label className="block text-sm text-gray-600" for="price">Stock Amount</label>
                                    <input className="w-full px-5  py-4 text-gray-700 bg-gray-200 rounded" id="stockamount"
                                        name="stock_amount"
                                        value={stock_amount}
                                        onChange={e => onInputChange(e)}
                                        type="text" required="true" placeholder="(ex:150)" aria-label="stockamount" />
                                </div>
                                <div className="mt-6">
                                    <button className="px-4 py-1 text-white font-light tracking-wider bg-gray-900 rounded" type="submit">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </main>

        </div>


    )
}

export default CreateBatch
